var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTwitter = function SvgIconTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 16 14",
    width: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.3438 3.75c.625-.46875 1.1874-1.03125 1.625-1.6875-.5626.25-1.2188.4375-1.875.5.6874-.40625 1.1874-1.03125 1.4374-1.8125-.625.375-1.3437.65625-2.0624.8125-.625-.65625-1.4688-1.03125-2.4063-1.03125-1.8125 0-3.28125 1.46875-3.28125 3.28125 0 .25.03125.5.09375.75-2.71875-.15625-5.15625-1.46875-6.78125-3.4375-.28125.46875-.4375 1.03125-.4375 1.65625 0 1.125.5625 2.125 1.46875 2.71875-.53125-.03125-1.0625-.15625-1.5-.40625v.03125c0 1.59375 1.125 2.90625 2.625 3.21875-.25.0625-.5625.125-.84375.125-.21875 0-.40625-.03125-.625-.0625.40625 1.3125 1.625 2.24995 3.0625 2.28125-1.125.875-2.53125 1.4063-4.0625 1.4063-.28125 0-.53125-.0313-.78125-.0626 1.4375.9376 3.15625 1.4688 5.03125 1.4688 6.03125 0 9.31255-4.96875 9.31255-9.3125 0-.15625 0-.28125 0-.4375z",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-twitter.7607b421.svg";
export { ForwardRef as ReactComponent };